// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ImportMappingRequestKind,
} from "./types";


export default __t.row({
  requestId: __t.u128().name("request_id"),
  requestedBy: __t.identity().name("requested_by"),
  get kind() {
    return ImportMappingRequestKind;
  },
  profileJson: __t.string().name("profile_json"),
  currentSpecJson: __t.string().name("current_spec_json"),
  instruction: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
